import { Component } from 'react';
import { Tabs, Row, Col, Space, message } from 'antd';
import { EditOutlined } from "@ant-design/icons";
import { getLangList } from '@/lib/i18n';
import { ReButton, ReModal } from '@/components/refineElement';
import { showDelConfirm, getOnOkFunction } from "@/lib/antdElementFunction";
import RentConfig from "@/config/rent";
import { hasPermission } from "@/lib/permissionUtil";
import ModalGroup from './ModalGroup';
import Group from './Group';
import './index.less'

const { getAllItemGroupInfo, createItemGroupInfo, updateItemGroupInfo, deleteItemGroupInfo } = RentConfig;
const { TabPane } = Tabs;

interface state {
  isModalVisible: boolean;
  handleType: string;
  allGroupArray: any;
  selectedGroupId: string;
  groupInfo: any;
}

class Rent extends Component<{}, state> {
  state = {
    isModalVisible: false,
    handleType: '',
    allGroupArray: [] as never as any,
    selectedGroupId: '',
    groupInfo: {} as never as any,
  };
  rentT: any = getLangList("rent");
  errorT: any = getLangList("error");

  componentDidMount() {
    this.getAllItemGroupInfo();
  }

  getAllItemGroupInfo = () => {
    getAllItemGroupInfo().then((res: any) => {
      const allGroupArray = res?.value ?? [];
      this.setState({ allGroupArray }, this.selectFirstGroupIndex);
    });
  }

  toggleModal = (handleType: string = '') => {
    const { isModalVisible } = this.state;
    this.setState({ isModalVisible: !isModalVisible, handleType });
  }

  clickCreate = () => {
    this.setState({ groupInfo: {} }, () => this.toggleModal('create'));
  }

  clickEdit = (data: object) => (e: any) => {
    e.stopPropagation();
    this.setState({ groupInfo: data }, () => this.toggleModal('update'));
  }

  clickDelete = () => {
    const { selectedGroupId } = this.state;
    showDelConfirm(() => this.deleteItemGroupInfo(selectedGroupId));
  };

  createItemGroupInfo = (values: any) => {
    const { groupName } = values;
    const params = { groupName };

    createItemGroupInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getAllItemGroupInfo();
    });
  }

  updateItemGroupInfo = (values: any) => {
    const { groupInfo } = this.state;
    const { groupId } = groupInfo;
    const { groupName } = values;
    const params = { groupId, groupName };

    if (!hasPermission('RENT_EDIT')) {
      return message.error(this.errorT.NO_PERMISSION);
    }

    updateItemGroupInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getAllItemGroupInfo();
    });
  }

  deleteItemGroupInfo = (id: string) => {
    const params = { itemGroupId: id };

    deleteItemGroupInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getAllItemGroupInfo();
    });
  }

  selectFirstGroupIndex = () => {
    const { allGroupArray } = this.state;
    const selectedGroupId = allGroupArray.length > 0 ? allGroupArray[0].groupId.toString() : '';
    this.setState({ selectedGroupId });
  }

  renderGroupTab = () => {
    const { allGroupArray, selectedGroupId } = this.state;
    return allGroupArray.map((item: any) => {
      const { groupName, groupId } = item;
      return (
        <TabPane
          key={groupId}
          tab={
            <Space>
              <span>{groupName}</span>
              {selectedGroupId === groupId.toString() && hasPermission(['RENT_EDIT', 'RENT_DELETE']) &&
                <span onClick={this.clickEdit(item)}><EditOutlined /></span>
              }
            </Space>
          }
        >
          <Group selectedGroupId={selectedGroupId} />
        </TabPane >
      );
    });
  }

  selectGroup = (activeKey: string) => this.setState({ selectedGroupId: activeKey });

  render() {
    const { isModalVisible, handleType, groupInfo, selectedGroupId } = this.state;
    const okFunction = {
      create: this.createItemGroupInfo,
      update: this.updateItemGroupInfo,
    };

    return (
      <>
        <Row className="rent-page">
          <Col span={24}>
            <Tabs
              onChange={this.selectGroup}
              activeKey={selectedGroupId}
              type="card"
              tabBarExtraContent={hasPermission('RENT_NEW') &&
                <ReButton iconName='plus' onClick={this.clickCreate}>
                  {this.rentT.NEW_CATEGORY}
                </ReButton>
              }
            >
              {this.renderGroupTab()}
            </Tabs>
          </Col>
        </Row>
        {isModalVisible &&
          <ReModal
            title={this.rentT.CATEGORY}
            onCancel={() => this.toggleModal()}
            visible={isModalVisible}
            onOk={(data: any) => getOnOkFunction(handleType, data, okFunction)}
            CollectedForm={ModalGroup}
            formProps={{
              handleType,
              groupInfo,
              clickDelete: this.clickDelete,
            }}
          />
        }
      </>
    );
  }
}

export default Rent;